import { render, staticRenderFns } from "./QLeadAllocationLogDataTable.vue?vue&type=template&id=313bba9c&scoped=true&"
import script from "./QLeadAllocationLogDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadAllocationLogDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadAllocationLogDataTable.vue?vue&type=style&index=0&id=313bba9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bba9c",
  null
  
)

export default component.exports